export const PartnerAgreementInitialState = {
  partnerAgreement: {
    id: null,
    salesforceId: "",
    legalName: "",
    telephone: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    stateWithCountry: null,
    zip: "",
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    commissionRate: 0,
    bonus: 0,
    agreementHash: "",
    agree: false,
  },
  error: {
    errorCode: 0,
    errorMessage: "",
  },

  isProcessing: false,

  commitment: {
    partnerAgreement: null,
    legalName: "",
    email: "",
    signatureImageBase64: "",
    signatureName: "",
  }
};



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/model.js